import { defineStore } from "pinia";
import { useRoute } from "vue-router";
import { useContentStore } from './contentStore';
import { computed } from 'vue';

export const useLocalizationStore = defineStore("localizationStore", () => {
    const contentStore = useContentStore();

    const route = useRoute();

    function trans(key) {
        if (!contentStore.content.translations[key]) {
            return key;
        }

        return contentStore.content.translations[key][route.params["locale"]];
    }

    function localize(obj) {
        return obj[route.params["locale"]] ?? "";
    }

    const languages = computed(() => {
        return contentStore.content.languages ?? [];
    })

    return {
        $trans: trans,
        $localize: localize,
        languages
    };
});
